//const LOCAL = 'http://localhost:5000/celina-tienda/us-central1/app/api'
//const LOCAL2 = 'http://localhost:5001/celina-tienda/us-central1/app/api'
const ONLINE = 'https://us-central1-celina-tienda.cloudfunctions.net/app/api'
export const API = ONLINE
